export namespace IInvoice {
  export type StateType = 'NOT_PAYABLE' | 'UNPAID' | 'OVERDUE' | 'PAID';

  export enum State {
    /**
     * The brand order is not shipped yet and can not be paid.
     */
    NOT_PAYABLE = 'NOT_PAYABLE',
    /**
     * The brand order has shipped and can be paid.
     */
    UNPAID = 'UNPAID',
    /**
     * The brand order should be paid but it is not.
     */
    OVERDUE = 'OVERDUE',
    /**
     * The brand order is paid either by regular payment or payment/installment plan.
     */
    PAID = 'PAID',
  }

  export type PaymentPlanEligibilityType =
    | 'NONE'
    | 'OVERDUE_ELIGIBLE'
    | 'LAUNCH_WITH_FAIRE_ELIGIBLE';

  export enum PaymentPlanEligibility {
    /**
     * The invoice has no eligible payment plan.
     */
    NONE = 'NONE',
    /**
     * The invoice can be enrolled into overdue payment plan.
     */
    OVERDUE_ELIGIBLE = 'OVERDUE_ELIGIBLE',
    /**
     * The invoice can be enrolled into launch with faire payment plan.
     */
    LAUNCH_WITH_FAIRE_ELIGIBLE = 'LAUNCH_WITH_FAIRE_ELIGIBLE',
  }

  export type PaymentStatusTextTypeType = 'ALARM' | 'NORMAL';

  export enum PaymentStatusTextType {
    ALARM = 'ALARM',
    NORMAL = 'NORMAL',
  }

  export namespace IPaymentStatusData {
    /**
     * Return an instance of IPaymentStatusData with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IPaymentStatusData>
    ): IPaymentStatusData =>
      ({
        ...(partial ?? {}),
      }) as IPaymentStatusData;
  }

  export interface IPaymentStatusData {
    text: string | undefined;
    type: keyof typeof IInvoice.PaymentStatusTextType | undefined;
  }

  /**
   * Return an instance of IInvoice with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IInvoice>): IInvoice =>
    ({
      ...(partial ?? {}),
    }) as IInvoice;
}

export interface IInvoice {}
